@use '@lib/assets/styles/main.scss' as *;
.actionHistory {
  padding: 12px;
  & > div + div {
    margin-top: 12px;
  }
}
